var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCz = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h640v240H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d7141a",
  d: "M0 240h640v240H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#11457e",
  d: "M360 240 0 0v480z"
})));
export { SvgCz as ReactComponent };
export default __webpack_public_path__ + "assets/images/cz.5a24757d105fbe7a4e81f64549ec8d2e.svg";